import React, { useCallback, useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "@app/state";
import {
  selectCurrentShowCaseTreeList,
  selectShowCaseTreeList,
} from "@app/state";
import { setShowCaseTreeList } from "@app/state";
import { JGAPCommonTree } from "@app/components/treeListCommon";
import { ShowCaseListIco, ShowCaseListTitle } from "./items";

import "./showcasetree.scss";

export const ShowCaseTreeList = () => {
  const [nodeId, setNodeId] = useState<string[]>([]);
  const theStateNode = useAppSelector(selectCurrentShowCaseTreeList);
  const dispatch = useAppDispatch();

  const cellRender = useCallback(
    (e: any) => (
      <div>
        <ShowCaseListIco e={e} />
        <ShowCaseListTitle e={e} />
      </div>
    ),
    []
  );

  const ptlSelectionChanged = useCallback((e: any) => {
    dispatch(setShowCaseTreeList(e.selectedRowsData[0]));
  }, []);

  useEffect(() => {
    if (theStateNode?.id && theStateNode.id !== nodeId[0]) {
      setNodeId([theStateNode.id]);
    }
  }, [theStateNode?.id || ""]);

  return (
    <JGAPCommonTree
      treeId={"showCaseTreeList"}
      treeDataSelector={selectShowCaseTreeList}
      currenNodeSelector={selectCurrentShowCaseTreeList}
      cellRender={cellRender}
      treeSelectionChanged={ptlSelectionChanged}
    />
  );
};
